import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { AppShell } from "@/components/layout/AppShell";
import { HomePage } from "@/components/layout/HomePage";
import { TemplateEditorPage } from "@/components/builder/TemplateEditorPage";
import { TemplateList } from "@/components/templates/TemplateList";
import { EvaluationList } from "@/components/filler/EvaluationList";
import { UnifiedEditorPage } from "@/components/unified/UnifiedEditorPage";
import { useTemplateStore } from "@/store/useTemplateStore";
import { useEvaluationStore } from "@/store/useEvaluationStore";
import { ToastProvider } from "@/components/ui/Toast";
import { EvaluationListSkeleton } from "@/components/ui/Skeleton";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Wordmark } from "@/components/ui/Wordmark";

function DataLoader({ children }: Readonly<{ children: React.ReactNode }>) {
  const loadTemplates = useTemplateStore((s) => s.load);
  const templatesLoaded = useTemplateStore((s) => s.loaded);
  const loadEvaluations = useEvaluationStore((s) => s.load);
  const evaluationsLoaded = useEvaluationStore((s) => s.loaded);

  useEffect(() => {
    void loadTemplates();
    void loadEvaluations();
  }, [loadTemplates, loadEvaluations]);

  if (!templatesLoaded || !evaluationsLoaded) {
    return (
      <div className="app-shell">
        <header className="app-header">
          <div className="hamburger-container">
            <button className="hamburger-btn" disabled>
              &#9776;
            </button>
          </div>
          <h1 className="app-logo">
            <img src="/logo.svg" alt="" width="26" height="26" />
            <Wordmark />
          </h1>
        </header>
        <main className="app-main">
          <EvaluationListSkeleton />
        </main>
      </div>
    );
  }

  return <>{children}</>;
}

export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ToastProvider>
          <DataLoader>
            <Routes>
              <Route element={<AppShell />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/templates" element={<TemplateList />} />
                <Route
                  path="/build"
                  element={<div className="placeholder">Select or create a template</div>}
                />
                <Route path="/build/:id" element={<TemplateEditorPage />} />
                <Route path="/fill" element={<EvaluationList />} />
                <Route path="/unified/:evalId" element={<UnifiedEditorPage />} />
              </Route>
            </Routes>
          </DataLoader>
        </ToastProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
